import {
  CSSObject,
  getFontWeight,
  Theme,
  forBrands,
} from '@core-ui/react-stitch';
import getControlBeforeStyles from '../getControlBeforeStyles';

const setControlStylesForBananaRepublic = (theme: Theme): CSSObject => ({
  textAlign: 'left',
  color: theme.color.b2,
  backgroundColor: theme.color.inverse.b1,
  width: '6.25rem',
  padding: '0.375rem',
  borderBottom: `0.063rem solid ${theme.color.b2}`,
  '&::before': {
    ...getControlBeforeStyles(theme),
    backgroundPositionX: '0.5rem',
    backgroundPositionY: '1rem',
  },
  '&:hover': {
    backgroundColor: theme.color.wh,
    animation: 'none !important',
    outline: 'none',
  },
  '&:focus': {
    animation: 'none !important',
    outline: 'none',
  },
  fontWeight: getFontWeight('regular').fontWeight,
  fontSize: '1rem',
});

const getControlStyles =
  () =>
  (base: CSSObject, { theme }: { theme: Theme }): CSSObject => ({
    ...base,
    color: theme.color.b1,
    marginTop: 0,
    position: 'relative',
    width: '100%',
    textAlign: 'center',
    '&::before': {
      ...getControlBeforeStyles(theme),
      width: '0.5rem',
      right: '-0.5rem',
      backgroundSize: '100% auto',
      backgroundPositionX: 'right',
      marginLeft: '0.5rem',
      marginRight: '0.5rem',
    },
    ...(forBrands(theme, {
      br: setControlStylesForBananaRepublic,
      brfs: setControlStylesForBananaRepublic,
    }) as CSSObject),
  });

export default getControlStyles;
